import applicationHistories from "./applicationHistories";

const applicationHistoryService = [
    {
        matcher: 'applicationHistories',
        reply: config => {
            return [200, applicationHistories];
        }
    },
    {
        matcher: /applicationHistories\/(.*)/,
        reply: config => {
            const id = /applicationHistories\/(.*)/.exec(config.url)[1];
            const data = applicationHistories.find(item => item.uuid === id);
            return [200, data];
        }
    },
]

export default applicationHistoryService;